/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */
import { Button, Dialog, DialogContent, DialogTitle, DialogContentText, DialogActions } from "@material-ui/core";

/**
 * Component used to manage agents
 * @param {Set} setShowSyncAgentModal used to set the state of modal
 * @param {Boolean} showSyncAgentModal used to control open/closed state of the modal
 * @param {Function} syncAgentsHandler function use to sync the agents from amazon connect
 */
export const SyncAgents = ({ setShowSyncAgentModal, showSyncAgentModal, syncAgentsHandler }) => {
	return (
		<Dialog
			open={showSyncAgentModal}
			onClose={() => setShowSyncAgentModal(false)}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">Sync Amazon Connect Agents?</DialogTitle>
			<DialogContent>
				<DialogContentText id="confirm-dialog-description">
					This process will sync all users in Amazon Connect to the VM portal.
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button variant="outlined" onClick={() => setShowSyncAgentModal(false)} color="primary">
					Cancel
				</Button>
				<Button
					variant="contained"
					onClick={() => {
						syncAgentsHandler();
						setShowSyncAgentModal(false);
					}}
					color="secondary"
					autoFocus
				>
					Sync
				</Button>
			</DialogActions>
		</Dialog>
	);
};
